var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcAddAvatar = function SvgIcAddAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9448AF",
    stroke: "#280982",
    strokeWidth: 1.6,
    d: "M15.808 1.542c-.47-.19-.996-.19-1.466 0L2.022 6.523a1.955 1.955 0 0 0-1.209 2.04L2.938 26.63a1.96 1.96 0 0 0 1.24 1.597l10.195 3.92c.452.174.952.174 1.404 0l10.195-3.92a1.96 1.96 0 0 0 1.24-1.597l2.125-18.065a1.955 1.955 0 0 0-1.21-2.041z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#926DFC",
    d: "M15.17 2.204V18.08l11.181 8.727a1.16 1.16 0 0 1-.667.672L15.49 31.4q-.155.06-.32.073v-11.66L1.752 7.762c.126-.22.323-.398.57-.498l12.32-4.98c.17-.07.35-.096.529-.081"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A55E1",
    d: "M15.603 4.027a1.16 1.16 0 0 0-.866 0L3.94 8.392a1.155 1.155 0 0 0-.714 1.206L5.09 25.462c.05.426.332.789.732.943l8.933 3.435c.267.103.562.103.829 0l8.932-3.435c.4-.154.682-.517.732-.943l1.867-15.864a1.155 1.155 0 0 0-.714-1.206z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.093,
    height: 12.371,
    x: 21.482,
    y: 15.012,
    fill: "#fff",
    rx: 1.546,
    transform: "rotate(90 21.482 15.012)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.093,
    height: 12.371,
    x: 16.843,
    y: 22.744,
    fill: "#fff",
    rx: 1.546,
    transform: "rotate(-180 16.843 22.744)"
  })));
};
export default SvgIcAddAvatar;